// Spec 078 US5 — o botão "Links de exibição" (GESTOR) da faixa do fluxo, dono do estado do
// diálogo para o card do fluxo não crescer. O diálogo (e as suas queries) só montam ao abrir.
import * as React from "react";
import { Tv } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DisplayLinksDialog } from "./DisplayLinksDialog";

export interface DisplayLinksButtonProps {
  lineId: string;
  lineName: string;
}

export function DisplayLinksButton({
  lineId,
  lineName,
}: DisplayLinksButtonProps): React.ReactElement {
  const [open, setOpen] = React.useState(false);
  return (
    <>
      <Button
        size="sm"
        variant="outline"
        onClick={() => setOpen(true)}
        aria-label="Links de exibição"
      >
        <Tv className="h-4 w-4" aria-hidden />
        Links de exibição
      </Button>
      {open ? (
        <DisplayLinksDialog lineId={lineId} lineName={lineName} onClose={() => setOpen(false)} />
      ) : null}
    </>
  );
}
